import { XStack, YStack } from "tamagui";

import type {
  ZocdocProviderResult,
  ZocdocProviderReviews,
  ZocdocTimeslot,
} from "@/api/generated/models";
import { Button, Heading, Paragraph } from "@/components";
import { formatDayHeading, formatTime, todayYMD } from "@/utils/datetime";
import { PhaseContainer } from "./PhaseContainer";
import { ProviderCard } from "./ProvidersPhase";

type DayPhaseProps = {
  selectedProvider: ZocdocProviderResult;
  carrierName: string | null;
  reviews: ZocdocProviderReviews | null;
  selectedDate: string;
  timeslots: ZocdocTimeslot[];
  onSelectTimeslot: (timeslot: ZocdocTimeslot) => void;
  onBack: () => void;
};

export const DayPhase = ({
  selectedProvider,
  carrierName,
  reviews,
  selectedDate,
  timeslots,
  onSelectTimeslot,
  onBack,
}: DayPhaseProps) => {
  const today = todayYMD();
  const daySlots = timeslots.filter(
    (s) => s.start_time.slice(0, 10) === selectedDate,
  );
  const datesWithSlots = new Set<string>();
  for (const slot of timeslots) {
    datesWithSlots.add(slot.start_time.slice(0, 10));
  }
  return (
    <PhaseContainer currentStep={5} onBack={onBack}>
      <ProviderCard
        provider={selectedProvider}
        carrierName={carrierName}
        reviews={reviews}
      />
      <XStack height="$450" alignItems="center">
        <Heading size="$sm">{formatDayHeading(selectedDate, today)}</Heading>
      </XStack>
      {daySlots.length === 0 ? (
        <Paragraph size="$sm" color="$textSecondary">
          No available timeslots on this day.
        </Paragraph>
      ) : (
        <XStack flexWrap="wrap" marginHorizontal="$-50">
          {daySlots.map((slot) => (
            <YStack key={slot.start_time} width="25%" padding="$50">
              <Button
                dataTrackingId="zocdoc-provider-timeslot"
                mode="secondary"
                width="100%"
                onPress={() => onSelectTimeslot(slot)}
                disabled={!slot.booking_url}
              >
                {formatTime(slot.start_time)}
              </Button>
            </YStack>
          ))}
        </XStack>
      )}
      {selectedProvider.statement && (
        <>
          <Heading size="$sm">About</Heading>
          <Paragraph size="$sm" color="$textSecondary">
            {selectedProvider.statement}
          </Paragraph>
        </>
      )}
    </PhaseContainer>
  );
};
